// Pull-to-refresh — SÓ no app (Capacitor). Arrastar pra baixo no topo da tela
// recarrega a página (re-busca os dados). A web não precisa. É pulado na tela
// do MAPA (lá arrastar move o mapa) e em telas sem scroll no topo.
//
// Idempotente. Inicializado por wireMoreSheet (shared/nav.js), uma vez por página.

let _wired = false;
// Distância de DEDO (px) pra disparar o refresh. Alto de propósito: o gesto
// precisa ser deliberado (arrasto longo), não sensível a toques curtos.
const THRESHOLD = 150;
// Até onde o spinner desce enquanto o usuário puxa — perto do meio da tela,
// pra ficar bem visível (e não escondido no topo). Recalculado no move.
function _targetPull() {
  const vh = window.innerHeight || 700;
  return Math.min(vh * 0.4, 280);
}

const STYLE = `
.ptr-spinner{position:fixed;left:50%;top:0;z-index:2100;
  width:36px;height:36px;margin-left:-18px;border-radius:50%;
  background:var(--bg-card,#1a0a21);box-shadow:0 4px 14px rgba(0,0,0,.3);
  display:flex;align-items:center;justify-content:center;
  transform:translateY(-120%);opacity:0;pointer-events:none;
  transition:opacity .15s ease;}
.ptr-spinner::after{content:"";width:16px;height:16px;border-radius:50%;
  border:2px solid var(--accent,#a06f3d);border-top-color:transparent;}
.ptr-spinner.ready::after{border-top-color:var(--accent,#a06f3d);}
.ptr-spinner.refreshing::after{animation:ptr-spin .7s linear infinite;}
@keyframes ptr-spin{to{transform:rotate(360deg)}}
`;

export function initPullToRefresh() {
  if (_wired || typeof window === 'undefined' || !window.__MAPIARE_NATIVE__) return;
  // Mapa/legacy: arrastar é do mapa, não recarrega.
  // Roteiro/Carteira/Documentos: têm botão de atualizar próprio no header
  // (ícone giratório) — não usam o gesto de arrastar-pra-atualizar.
  if (/\/(mapa|legacy|roteiro|carteira|documents)\.html/.test(location.pathname)) return;
  _wired = true;

  if (!document.getElementById('ptrStyle')) {
    const s = document.createElement('style');
    s.id = 'ptrStyle';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  const spinner = document.createElement('div');
  spinner.className = 'ptr-spinner';
  spinner.setAttribute('aria-hidden', 'true');

  const scroller = document.scrollingElement || document.documentElement;
  let startY = 0;
  let pulling = false;
  let dist = 0;

  const mount = () => { if (!spinner.isConnected) document.body.appendChild(spinner); };
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount, { once: true });

  const reset = () => {
    spinner.style.transform = 'translateY(-120%)';
    spinner.style.opacity = '0';
    spinner.classList.remove('ready');
  };

  window.addEventListener('touchstart', (e) => {
    if (scroller.scrollTop > 0 || e.touches.length !== 1) { pulling = false; return; }
    startY = e.touches[0].clientY;
    pulling = true;
    dist = 0;
  }, { passive: true });

  window.addEventListener('touchmove', (e) => {
    if (!pulling) return;
    dist = e.touches[0].clientY - startY;
    if (dist <= 0 || scroller.scrollTop > 0) { reset(); return; }
    // Mapeia o arrasto [0..THRESHOLD] → spinner [0..meio da tela], e continua
    // descendo devagar além do limite (feedback de "já pode soltar").
    const target = _targetPull();
    const progress = Math.min(dist / THRESHOLD, 1);
    const extra = Math.max(0, dist - THRESHOLD) * 0.15;
    const pull = target * progress + extra;
    spinner.style.transform = `translateY(${pull}px)`;
    spinner.style.opacity = String(Math.min(1, dist / (THRESHOLD * 0.4)));
    spinner.classList.toggle('ready', dist >= THRESHOLD);
  }, { passive: true });

  window.addEventListener('touchend', () => {
    if (!pulling) return;
    const trigger = dist >= THRESHOLD;
    pulling = false;
    dist = 0;
    if (trigger) {
      spinner.classList.add('refreshing');
      spinner.style.transform = `translateY(${_targetPull()}px)`;
      spinner.style.opacity = '1';
      location.reload();
    } else {
      reset();
    }
  }, { passive: true });
}
